import React from 'react';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { Separator } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './agency-details.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AgencyDetails = _ref => {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance,
    agencyLogo = _ref.agencyLogo,
    agencyProfileUrl = _ref.agencyProfileUrl,
    agencyLogoBackgroundColour = _ref.agencyLogoBackgroundColour,
    title = _ref.title;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var isPremium = appearance === 'premium';
  return ___EmotionJSX("div", {
    css: styles.agencyDetails(isPremium)
  }, !isPremium && ___EmotionJSX(Separator, {
    css: styles.divider
  }), ___EmotionJSX("div", {
    css: styles.agencyInfoBox
  }, !isPremium && agencyLogo && ___EmotionJSX("a", {
    href: agencyProfileUrl,
    onClick: () => sendEvent('agency-logo-click')
  }, ___EmotionJSX("div", {
    css: styles.agencyLogoBox(agencyLogoBackgroundColour || '')
  }, ___EmotionJSX("img", {
    css: styles.agencyLogo,
    src: agencyLogo,
    alt: "Agency Logo",
    "data-test-id": "agency-logo"
  }))), ___EmotionJSX("h1", {
    css: styles.agencyName
  }, title), ___EmotionJSX("div", null, ___EmotionJSX("a", {
    css: styles.agencyProfileLink,
    href: agencyProfileUrl
  }, "View agency profile"))));
};
export { AgencyDetails };